import { getContext, setContext } from 'svelte'

import { preloadData, pushState, goto, beforeNavigate, afterNavigate, invalidateAll, onNavigate } from '$app/navigation'
import { page } from '$app/state'
import { getPageStateContext, PageStateContext } from './PageStateContext.svelte'
import { ResultSync } from '$lib/utils/result'

const CONTEXT = Symbol('BODY')

export function createBodyContext(): BodyContext {
      return setContext(CONTEXT, new BodyContext())
}

export function getBodyContext(): BodyContext {
      return getContext(CONTEXT)
}

let pageState: PageStateContext

class BodyContext {
      opened = $derived.by(() => {
            if (!pageState) return false
            return pageState.getState('body-open') ?? false
      })

      constructor() {
            pageState = getPageStateContext()

            return this
      }



      toggle() {
            //this.opened = !this.opened
            //pageState.pushState('body-open', !this.opened)
            if (this.opened) this.close()
            else this.open()
            return this
      }

      open() {
            //this.opened = true
            pageState.pushState('body-open', true)
            return this
      }

      close() {
            //this.opened = false
            //pageState.pushState('body-open', false)
            pageState.goBack()
            return this
      }

      closeWithoutBack() {
        pageState.replaceState("body-open", false)
        return this
      }

      async closeAndGoto(url: string) {
        history.back()
        await this.waitForNavigation()
        goto(url, {
          state: {
            ...pageState.state,
            "body-open": false
          }
        })

      }

      async waitForNavigation() {
        const ctrl = new AbortController()
        return new Promise( r => {
          window.addEventListener("popstate", () => {
            r(true)
            ctrl.abort()
          }, { signal: ctrl.signal })
        })
      }
}
